import { formatTime } from '../modules/exam/libs/timeformate.js'
export default {
    data() {
        return {
            combinationFlag: false, // 当前是否为组合题
            toName: '',
            questionsHandle: [] // 答题卡处理过的展示数据
        }
    },
    watch: {
        questionsList: {
            handler: function (newV) {
                console.log(newV, 'newV===')
                let arr = []
                arr = newV.filter(item => {
                    return item.responds === 1
                })
                console.log(arr, '已经答题的arr')
                this.rightCount = arr.length
                this.questionsHandle = this.arryGroupMatch(newV, 'type')
                console.log(222, this.questionsHandle)
            },
            deep: true
        }
    },
    beforeRouteEnter(to, from, next) {
        // ...

        next(vm => {
            console.log(to.name, 'to.name')
            vm.toName = to.name
        })
    },
    methods: {
        arryGroupMatch(data, attribute) {
            // 根据某个类型处理数据源
            // data 原数据
            // attribute 根据某个属性做处理
            let c = []
            let d = {}
            let topicTypeObj = {
                1: '单选题',
                2: '多选题',
                3: '判断题',
                4: '高阶',
                5: '问答题',
                6: '填空',
                7: '组合题'
            }
            data.forEach((element, index) => {
                element.questionNo = index // 根据下标 定为题号
                const type = element[attribute]
                if (!d[type]) {
                    c.push({
                        [attribute]: type,
                        topicType: topicTypeObj[type],
                        values: [element]
                    })
                    d[type] = element
                } else {
                    c.forEach(ele => {
                        if (ele[attribute] === type) ele.values.push(element)
                    })
                }
            })
            c.forEach(v => {
                let totalScore = 0
                v.values.forEach((val, idx) => {
                    totalScore += val.score
                    if (v.type == 7) {
                        // 组合题    记录当前是第几个组合题
                        // v.combinationIdx = idx
                        // val.
                    }
                })
                v.score = Math.round(totalScore)
                v.total = v.values.length
            })
            return c
        },
        // 单个题目提交
        async singleCommit(val, type) {
            console.log('单个提交', val, type)
            console.log(this.allAnswer)
            console.log(this.toName, 'this.toName')
            if (this.toName === 'testpage') {
                this.singleParams = {
                    answerList: [val],
                    commitTime: formatTime(new Date()),
                    practiceId: this.examParams.userPracticeId
                }
                await this.$api.coursetest.commitPaper(this.singleParams)
            } else if (this.toName === 'examTaking') {
                this.singleParams = {
                    answerList: [val],
                    commitTime: formatTime(new Date()),
                    userPaperId: this.examParams.userPaperId
                }
                await this.$api.coursetest.userPaperCommitPaper(this.singleParams)
            }
            console.log(this.toName, 'this.toName')
            console.log(this.singleParams, 'this.singleParams')
            let combinationNext = false // 是不是组合题的最后一个
            if (this.combinationFlag) {
                // 组合题 最后一个 当前大题也是最后一个 设置false 不在切换下一个大题
                if (this.subQuestion.lastOne && this.currentRanking === this.examTotal) {
                    combinationNext = false
                } else combinationNext = true
            }

            const responds = this.combinationFlag
                ? this.subQuestion.responds
                : this.questionsList[this.currentRanking - 1].responds
            console.log(
                combinationNext,
                this.subQuestion.lastOne,
                this.currentRanking,
                this.examTotal,
                '单个提交=》查看是否组合题最后一个'
            )
            const typeArr = [2, 5,6] // 需要排除的题类型=>不做自动切换下一题
            const currentQuestionTypeFlag = !typeArr.includes(this.currentQuestion.type)
            const subTypeFlag = !typeArr.includes(this.subQuestion.type)
            if (
                (this.currentRanking !== this.examTotal || type === 'next' || combinationNext) &&
                responds === 1 &&
                currentQuestionTypeFlag &&
                subTypeFlag
            ) {
                console.log('切换到下一题')
                this.changeTopic({ type: 'next', tag: 1 })
            }
        },
        findSomeOne() {
            this.moreanswer = []
            this.chooseNum = null
            const type = this.combinationFlag ? this.subQuestion.type : this.currentQuestion.type

            console.log(
                this.allAnswer,
                'findSomeOne===',
                this.currentQuestion.options,
                this.combinationFlag,
                this.subQuestion.optionList,
                type
            )
            // 问答、填空不走配置
            if ([5,6].includes(type)) return
            this.allAnswer.forEach(val => {
                const key = this.combinationFlag ? 'subQuestionId' : 'questionId'
                if (this.currentQuestion.options || this.subQuestion.optionList) {
                    let questionId = this.combinationFlag
                        ? this.subQuestion.optionList[0].questionId
                        : this.currentQuestion.options[0].questionId
                    if (val[key] === questionId) {
                        if (type === 2) {
                            this.moreanswer = val.answer.split(',').filter(str => !!str)
                        } else this.chooseNum = val.answer
                    }
                }
            })
            console.log(this.chooseNum, 'findSomeOne结束')
        },
        // 跳转到指定题目
        async toThisOne(index, questionIdx) {
            console.log('toThisOne点击答题卡上的数字', index, questionIdx, this.questionsList[index])
            this.currentRanking = index + 1
            this.isSheetShow = false
            this.currentQuestion = this.questionsList[index]
            if (this.currentQuestion.type == 7) {
                this.combinationFlag = true
                this.subQuestion = this.currentQuestion.subDtoList[questionIdx]
            } else {
                this.combinationFlag = false
                this.subQuestion = {}
            }
            console.log(this.currentQuestion, 'currentQuestion===')
            // 多选题需要去重
            if (this.moreChoose) {
                await this.repetAnswer(this.moreChoose)
                await this.singleCommit(this.moreChoose, 'prev')
            }

            console.log('跳转指定题目')
            this.findSomeOne()
            this.moreChoose = null
        },
        // 去重
        async repetAnswer(params) {
            console.log(params, this.allAnswer, 'repetAnswer')
            if (!params) return false
            if (this.allAnswer.length > 0) {
                this.allAnswer.forEach(item => {
                    const key = this.combinationFlag ? 'subQuestionId' : 'questionId'
                    if (params[key] === item[key]) {
                        this.allAnswer.splice(this.allAnswer.indexOf(item), 1)
                        this.ismark === 1 ? (params.mark = 1) : (params.mark = 0)
                    }
                })
            }
            return this.allAnswer.push(params)
        },
        // 切换题目
        async changeTopic({ type, tag }) {
            // type => next/prev    上一题/下一题
            // tag 不知道该字段的意义
            console.log(this.allAnswer,'changeTopic=>allAnswer');
            console.log(this.currentParams,'changeTopic=>currentParams');
            console.log(this.moreChoose,'changeTopic=>moreChoose');
            this.pushState()
            this.chooseNum = null
            this.repetAnswer(this.moreChoose)
            if ((type === 'next' && !tag) || (this.currentRanking === this.examTotal && type !== 'next')) {
                console.log(this.moreChoose, this.currentQuestion.mark, 'this.moreChoose')
                if (this.currentParams || this.moreChoose) {
                    await this.singleCommit(this.moreChoose || this.currentParams, type)
                    this.moreChoose = null
                    this.currentParams = null
                    console.log(3333, '有题，请求接口', this.combinationFlag)
                }
            }
            if (this.combinationFlag) {
                // 如果是组合题 执行特殊处理
                this.combinationFn(type)
            } else {
                let num = this.questionsList.indexOf(this.currentQuestion)
                num = num !== 0 && type === 'prev' ? num - 1 : num + 1
                this.currentQuestion = this.questionsList[num]
                if (this.currentQuestion.type == 7) {
                    this.combinationFlag = true
                    this.combinationFn(type)
                }
                this.currentRanking = num + 1
            }
            if (!this.justWatch) {
                this.findSomeOne()
            }
        },
        // 组合题处理函数
        combinationFn(type) {
            console.log('执行组合题特殊处理', type, this.combinationFlag)
            let num = this.questionsList.indexOf(this.currentQuestion)
            num = num !== 0 && type === 'prev' ? num - 1 : num + 1
            if (type == 'prev') {
                if (this.subQuestion.first) {
                    // 第一子题、返回到上一个大题
                    this.currentQuestion = this.questionsList[num]
                    if (this.currentQuestion.type == 7) {
                        const length = this.currentQuestion.subDtoList.length
                        this.subQuestion = this.currentQuestion.subDtoList[length - 1]
                    } else {
                        this.combinationFlag = false
                        this.subQuestion = {}
                    }
                    this.currentRanking = num + 1 // 当前在第几题
                } else this.nextCombination(type)
            } else {
                console.log('执行组合题特殊处理==', type, this.subQuestion.lastOne)
                if (this.subQuestion.lastOne) {
                    // 最后一题、进入到下一个大题
                    this.currentQuestion = this.questionsList[num]
                    this.subQuestion = {}
                    if (this.currentQuestion.type == 7) {
                        this.combinationFlag = true
                        this.combinationFn()
                    } else this.combinationFlag = false
                    this.currentRanking = num + 1
                    console.log('查看是不是最后一个', this.currentRanking, this.examTotal, this.subQuestion)
                } else this.nextCombination(type)
            }
            console.log('子题数据：', this.subQuestion)
        },
        // 组合题下一子题处理函数
        nextCombination(type) {
            let questionIdx = this.currentQuestion.subDtoList.indexOf(this.subQuestion)
            questionIdx = questionIdx !== 0 && type === 'prev' ? questionIdx - 1 : questionIdx + 1
            this.subQuestion = this.currentQuestion.subDtoList[questionIdx]
        },
        setColor(item) {
            // console.log('答题卡颜色', this.justWatch, item)
            if (item.type === 6 && !this.justWatch) {
                let num = 0
                item.completionAnswer &&
                    item.completionAnswer.forEach(item => {
                        if (item.answer) {
                            num++
                        }
                    })
                if (num) {
                    return 'answeredTopic'
                } else if (item.result === 0 && item.reply) {
                    return 'errorTopic'
                } else {
                    return 'unansweredTopic'
                }
            } else {
                if (item.responds || (item.result === 1 && item.reply)) {
                    return 'answeredTopic'
                } else if (item.result === 0 && item.reply) {
                    return 'errorTopic'
                }
                if ((!item.reply && this.justWatch) || !item.responds) {
                    return 'unansweredTopic'
                }
            }
        },
        chooseColor(item) {
            let rightAnswer, userAnswer, type
            if (this.combinationFlag) {
                rightAnswer = this.subQuestion.rightAnswer
                userAnswer = this.subQuestion.userAnswer
                type = this.subQuestion.type
            } else {
                rightAnswer = this.currentQuestion.rightAnswer
                userAnswer = this.currentQuestion.userAnswer
                type = this.currentQuestion.type
            }
            let hasOne =
                this.moreanswer && this.moreanswer.length > 0 && this.moreanswer.indexOf(item.optionNumber) !== -1
            let chooseOne = this.chooseNum === item.optionNumber || userAnswer === item.optionNumber
            let rightOne = item.optionNumber === rightAnswer
            let errorOne = !rightOne
            if (!this.justWatch && (chooseOne || hasOne)) {
                return 'activeSpan'
            } else if (this.justWatch) {
                let moreRightOne =
                    rightAnswer.indexOf(item.optionNumber) !== -1 &&
                    userAnswer &&
                    userAnswer.indexOf(item.optionNumber) !== -1
                let moreErrorOne = rightAnswer.indexOf(item.optionNumber) !== -1 && type === 2
                if ((chooseOne && rightOne) || (hasOne && !errorOne) || moreRightOne) {
                    return 'activeSpan'
                } else if ((chooseOne && errorOne) || (errorOne && hasOne)) {
                    return 'cuoSpan'
                } else if (moreErrorOne) {
                    return 'activeSpan 1'
                }
            } else {
                return ''
            }
        }
    }
}
